import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import { useRegionalLink } from 'hooks/useRegionalLink';

import classes from './NetowrkCheckBody.module.scss';

const NetworkCheckBody = ({ hasNtcRules }) => {
  const history = useHistory();
  const generateRegionalPath = useRegionalLink();

  let newUrl = history.location.pathname.split('/');
  newUrl.pop();
  newUrl = newUrl.join('/');

  return (
    <nav className={classes.sublinks}>
      <NavLink
        className={classes.sublinks_item}
        activeClassName={classes.sublinks_item__active}
        to={generateRegionalPath(`${newUrl}/network`)}
      >
        {'Network'}
      </NavLink>
      <NavLink
        className={cn(classes.sublinks_item, !hasNtcRules && classes.disabled)}
        activeClassName={classes.sublinks_item__active}
        to={generateRegionalPath(`${newUrl}/firewall`)}
      >
        {'Firewall'}
      </NavLink>
    </nav>
  );
};

NetworkCheckBody.propTypes = {
  hasNtcRules: PropTypes.oneOfType([PropTypes.bool, PropTypes.number])
};

export default NetworkCheckBody;
